import { Static, Union } from "runtypes";

import { getNormalEnum } from "../runtypeEnums.js";

import { AnthropicModelLiteral } from "./anthropicTypes.js";
import { KimiModelLiteral } from "./chatCompletionsTypes.js";
import { OpenAiChatModelLiteral } from "./openAiTypes.js";

export const ModelNameLiteral = Union(
  ...AnthropicModelLiteral.alternatives,
  ...OpenAiChatModelLiteral.alternatives,
  ...KimiModelLiteral.alternatives,
);
export type ModelName = Static<typeof ModelNameLiteral>;
export const ModelName = getNormalEnum(ModelNameLiteral);
